import {Component, Input, OnInit} from '@angular/core';
import {ResultatService} from '../../../services/resultat.service';
import {Resultat} from '../../../shared/models/resultat.model';

/* tslint:disable:component-selector */
@Component({
  selector: '[app-resultat-table-item]',
  templateUrl: './resultat-table-item.component.html',
  styleUrls: ['./resultat-table-item.component.scss']
})
export class ResultatTableItemComponent implements OnInit {
  @Input() resultat: Resultat;
  @Input() rowIndex: number;

  collapse = true;

  hasAterbetalningsbelopp = false;

  constructor(private readonly resultatService: ResultatService) { }

  ngOnInit() {
    this.hasAterbetalningsbelopp = this.resultatService.hasAterbetalningsbelopp;
  }

  getIndex(): number {
    return this.rowIndex + 1;
  }

  tranformDigit(decimal: number): string {
    return this.resultatService.tranformDigitToLocaleString(decimal);
  }

  onCollapse() {
    this.collapse = !this.collapse;
    return false;
  }
}
